import Sign from './Sign';

export default class Word {
    constructor(key, signs) {
        this.key = key;
        this.signs = (signs || []).map(data => new Sign(data));

        this.selectedSign = 0;
    }

    static async find(key) {
        let response = await axios.get('/api/tegnbank?query=' + key);

        return new this(key, response.data.data);
    }
}
